import type { ConversionLang } from "@/data/internationalConversion";
import { internationalMessage as nativeMessage } from "./internationalMessage.js";
export interface RepairEnquiry { device?: string; issue?: string; neighborhood?: string; lang?: ConversionLang }
export function internationalMessage({ device = "[Device]", issue = "[Issue]", neighborhood = "[Neighborhood]", lang }: RepairEnquiry = {}) {
  const language = lang || (typeof window !== "undefined" ? window.location.pathname.split("/")[1] : "en");
  return nativeMessage({ lang: language, device, issue, neighborhood });
}
export function internationalWhatsApp(details: RepairEnquiry = {}) { return `https://wa.me/972585449992?text=${encodeURIComponent(internationalMessage(details))}`; }
